import { useCallback, useEffect } from "react";
import { useStore } from "@/hooks/useStore";
import { UserStorage } from "@/storage/UserStorage";
import { useAsyncStateStore } from "@/hooks/useAsyncStateStore";
import { auth } from "@/endpoints/dryp/auth";

/**
 * Initializes user session by checking authentication and fetching user data.
 */
export const useSessionInitialization = () => {
	const store = useStore();
	const getUserAndOrganizationApi = useAsyncStateStore(auth.getUserAndOrganization);

	const getUserAndOrganization = useCallback(() => {
		const isToken = UserStorage.hasToken();
		if (isToken) {
			getUserAndOrganizationApi.fetch();
		} else {
			store.setInitializing(false);
		}
	}, [getUserAndOrganizationApi, store]);

	// Runs once on mount: Checks local storage for auth and fetches user if needed.
	useEffect(() => {
		getUserAndOrganization();
	}, [getUserAndOrganization]);

	const { data, loaded } = getUserAndOrganizationApi;
	const { isLoggedIn } = store.userStore;
	// Once data is loaded, set user and organization if not already logged in.
	useEffect(() => {
		if (loaded) {
			if (!isLoggedIn && data) {
				store.userStore.setUserAndOrganization(data.user, data.organization, data.organizations);
				store.userStore.setLoggedIn();
			}
			// Ensures app initialization completes.
			store.setInitializing(false);
		}
	}, [data, isLoggedIn, loaded, store]);
};
